import { cn } from '@/lib/utils'
import { forwardRef, type ButtonHTMLAttributes } from 'react'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'outline' | 'danger'
  size?: 'sm' | 'md' | 'lg'
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', size = 'md', className, children, ...props }, ref) => {
    const base = 'inline-flex items-center justify-center font-medium rounded-lg transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-echo-mark focus-visible:ring-offset-2 disabled:bg-button-disabled-bg disabled:text-button-disabled-text disabled:border disabled:border-button-disabled-border disabled:cursor-not-allowed disabled:pointer-events-none disabled:shadow-none'
    const variants = {
      primary: 'bg-echo-mark text-paper hover:bg-echo-mark-hover active:bg-echo-mark-active',
      secondary: 'bg-signal-cyan text-deep-ink hover:bg-echo-mark-button-dark hover:text-paper',
      ghost: 'text-deep-ink hover:bg-soft-panel',
      outline: 'border border-border-gray text-deep-ink hover:bg-soft-panel',
      danger: 'bg-risk-rose text-white hover:bg-[#7D1B1E]',
    }
    const sizes = {
      sm: 'h-8 px-3 text-sm gap-1.5',
      md: 'h-10 px-4 text-sm gap-2 min-w-[44px]',
      lg: 'h-12 px-6 text-base gap-2.5',
    }
    return (
      <button ref={ref} className={cn(base, variants[variant], sizes[size], className)} {...props}>
        {children}
      </button>
    )
  }
)
Button.displayName = 'Button'
